module.exports = __webpack_public_path__ + "img/taste-table3.311cbc75.png";